import onGetStatusPatients from './onGetStatusPatients';
import onGetMoreStatusPatients from './onGetMoreStatusPatients';
import onUpdatedBloodPressureReading from './onUpdatedBloodPressureReading';

export default {
  onGetStatusPatients,
  onGetMoreStatusPatients,
  onUpdatedBloodPressureReading,
};
